import { Md5 } from "ts-md5";
import { g as generatePalette } from "../../chunks/colors-Cv9F-jWS.mjs";
function hashCode(str) {
  let hash = str;
  if (str.match(/^([0-9a-f]{4}-?){8}$/) === null) {
    hash = Md5.hashStr(str);
  }
  hash = hash.replace(/[^0-9a-f]/g, "");
  let finalInt = 0;
  for (let i = 0; i < hash.length; i++) {
    finalInt += parseInt(hash.charAt(i), 16);
  }
  return finalInt;
}
function usernameToColor(username) {
  const steps = 6;
  const finalPalette = generatePalette(steps);
  const hash = hashCode(username.toLocaleLowerCase());
  return finalPalette[hash % finalPalette.length];
}
export {
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
